const overlay = { 
	toggle: function() {
		document.querySelector('#overlay').classList.toggle('hidden');
	},

	hide: function() {
		document.querySelector('#overlay').style.opacity = '0';

		setTimeout(() => {
			document.querySelector('#overlay').classList.add('hidden');
		}, 500)

		document.body.removeAttribute('style');
	},

	show: function() {
		document.querySelector('#overlay').classList.remove('hidden');
		document.body.style.overflow = 'hidden';

		// set top and left to scroll position
		document.querySelector('#overlay').style.top = `${window.scrollY - 600}px`;
		document.querySelector('#overlay').style.left = `${window.scrollX}px`;

		setTimeout(() => {
			document.querySelector('#overlay').style.opacity = '0.7';
		}, 10)
	},

	onClick: function(callback) {
		document.querySelector('#overlay').addEventListener('click', callback);
	},
}

export default overlay;
